import React, { useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

export default function UserEmail() {
	const { accounts } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	const [email, setEmail] = useState("");

	useEffect(() => {
		if (isAuthenticated && accounts.length > 0) {
			const account = accounts[0];
			const userEmail = account.idTokenClaims?.email || account.username;
			setEmail(userEmail);
		}
	}, [isAuthenticated, accounts]);

	if (!isAuthenticated) return null;

	return <p style={{ textAlign: "center" }}>{email}</p>;
}
